import { EmptyPlaceholder } from '../empty-placeholder';
import { TableBody } from '../table/table-body';

export type TableContentProps = {
  emptyCaption: React.ReactNode;
  skeleton: React.ReactNode;
  list: React.ReactNode;
  fetching: boolean;
  initializing: boolean;
  empty: boolean;
}

/**
 * Wrapper for table content to either display caption, skeleton or the actual content
 */
export function TableContent({ skeleton, list, fetching, initializing, empty, emptyCaption }: TableContentProps) {
  const displayList = !initializing;
  const displayListEmptyCaption = displayList && !fetching && empty;
  const displayListSkeleton = !displayList || (fetching && empty);

  return (
    <>
      {displayListEmptyCaption && (
        <caption className="px-4 py-4 [caption-side:bottom]">
          <EmptyPlaceholder>
            {emptyCaption}
          </EmptyPlaceholder>
        </caption>
      )}

      <TableBody>
        {displayListSkeleton && skeleton}
        {displayList && list}
      </TableBody>
    </>
  );
}

export default TableContent;
